import { DefaultOptions, QueryCache, QueryClient } from '@tanstack/react-query';

// Default options for all queries
const defaultQueryOptions: DefaultOptions = {
  queries: {
    // Stale time of 5 minutes - data won't refetch until after this time
    staleTime: 5 * 60 * 1000,

    // Cache time of 10 minutes - unused data will be garbage collected after this time
    gcTime: 10 * 60 * 1000,

    // Retry failed requests
    retry: 0,

    // Retry delay between attempts (in milliseconds)
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),

    // Don't refetch on window focus
    refetchOnWindowFocus: false,

    // Don't refetch on reconnect
    refetchOnReconnect: false,

    // Don't refetch while component is mounted
    refetchOnMount: false,
  },
  mutations: {
    // Retry failed mutations
    retry: 0,
  },
};

// Create a client with default options
export const queryClient = new QueryClient({
  defaultOptions: defaultQueryOptions,
  queryCache: new QueryCache({
    onError: () => {
      // Only show error toasts if we haven't already
      // You could also integrate with your error reporting service here
    },
  }),
});

export const invalidateAllQueries = async () => {
  // Invalidate all queries
  await queryClient.invalidateQueries();
  // Reset all queries to ensure they refetch
  await queryClient.resetQueries();
  // Clear the query cache
  queryClient.clear();
};
